/* ONE TUNNE header behaviour.
 *
 * Two custom elements, no globals, no dependencies, progressive enhancement:
 * without this file the cart link still shows the count rendered by Liquid and the
 * mobile menu still opens and closes (native <details>/<summary>).
 *
 * <cart-count>        keeps the header cart counter in sync with the `cart:updated`
 *                     event dispatched by assets/cart.js (phase 6).
 * <header-disclosure> adds Escape-to-close and close-on-navigation to a <details>
 *                     disclosure (mobile menu, language and currency panel).
 */
(() => {
  if (!('customElements' in window)) return;

  if (!customElements.get('cart-count')) {
    customElements.define(
      'cart-count',
      class CartCount extends HTMLElement {
        connectedCallback() {
          this.handleUpdate = this.handleUpdate.bind(this);
          document.addEventListener('cart:updated', this.handleUpdate);
        }

        disconnectedCallback() {
          document.removeEventListener('cart:updated', this.handleUpdate);
        }

        handleUpdate(event) {
          const detail = event.detail || {};
          const cart = detail.cart || detail;
          // cart/add.js answers with the added items, not the cart, so item_count is absent
          // there; cart.js passes the real total (read from the re-rendered drawer) as itemCount.
          const count = Number.isFinite(detail.itemCount) ? detail.itemCount : Number(cart.item_count);
          if (!Number.isFinite(count)) return;

          const host = this.querySelector('[data-cart-count]') || this;
          const node = Array.from(host.childNodes)
            .reverse()
            .find((child) => child.nodeType === Node.TEXT_NODE && child.nodeValue.trim() !== '');

          if (node) node.nodeValue = String(count);
          else host.append(String(count));

          host.toggleAttribute('data-cart-empty', count === 0);
        }
      }
    );
  }

  if (!customElements.get('header-disclosure')) {
    customElements.define(
      'header-disclosure',
      class HeaderDisclosure extends HTMLElement {
        connectedCallback() {
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleClick = this.handleClick.bind(this);
          this.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
          this.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('click', this.handleClick);
        }

        close() {
          const details = this.querySelector('details');
          if (!details || !details.open) return;
          details.open = false;
          const summary = details.querySelector('summary');
          if (summary) summary.focus();
        }

        handleKeydown(event) {
          if (event.key === 'Escape') this.close();
        }

        handleClick(event) {
          if (event.target.closest('a')) this.close();
        }
      }
    );
  }
})();
